const shouldMountLearnMedsender = ({ user, isExternalPartner }) => (
  user !== null && !isExternalPartner
);

export default shouldMountLearnMedsender;
